define([
    "language/resource",
    "authui/iamUtils",
    "base/utils/iamHttpService",
    "base/widgets/graphicVerifyWindow/window"
], function (i18n, iamUtils, iamHttpService, GrahicVerifyWindow) {
    "use strict";

    var ctrl = function ($scope, securityPolicy) {
        $scope.i18n = i18n;
        document.title = i18n("titles.bindAccount");

        $scope.model = {
            url : sessionStorage.getItem("url"),
            bindRequest : sessionStorage.getItem("bindRequest"),
            Signature : sessionStorage.getItem("Signature"),
            SigAlg : sessionStorage.getItem("SigAlg"),
            loading: true,
        };
        init($scope, iamUtils);
    }

    function init($scope, iamUtils){
        var form = document.getElementById("notify_form");
        form.setAttribute("action",$scope.model.url);
        document.getElementById("bindRequest").value = $scope.model.bindRequest;
        document.getElementById("Signature").value = $scope.model.Signature;
        document.getElementById("SigAlg").value = $scope.model.SigAlg;
        form.submit();
        document.getElementById("notify_result").onload = function(){
            setTimeout(function(){
                $scope.model.loading = false;
                $scope.$apply();
            }, 1000)            
        }
    }

    var dvpRegisterModule = angular.module('authui.config');
    ctrl = ["$scope", "securityPolicy", ctrl];
    dvpRegisterModule.controller('authui.notify.ctrl', ctrl);
    return ctrl;
});



// WEBPACK FOOTER //
// ./public/hws/js/notify/controllers/notifyController.js